import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PageLayout from "../Layouts/PageLayout";
import { createBrowserRouter } from "react-router-dom";
import Main from './Main/Main';
import Usuarios from '../Pages/Usuarios/Usuarios'
import Rifas from '../Pages/Rifas/Rifas'
import Numeros from '../Pages/Numeros/Numeros'
import Banners from "./Banners/Banners";
import Contacto from "./Contacto/Contacto";
import Ganadores from "./Ganadores/Ganadores";
import Pagos from "./Pagos/Pagos";
import NumerosEspeciales from "./NumerosEspeciales/NumerosEspeciales";
import PageDetail from '../Pages/PageDetail/PageDetail';
import RouterErrorBoundary from '../Components/RouterErrorBoundary/RouterErrorBoundary';
import TicketVerification from '../Components/TicketVerification/TicketVerification';
import Dashboard2 from './Dashboard2/Dashboard2';
export const router = createBrowserRouter([

    {
        path: "/",
        element: <IndexLayout />,
        errorElement: <RouterErrorBoundary />,
        children: [
            {
                path: `/`,
                element: <Main />,
                errorElement: <RouterErrorBoundary />,
            },

        ],
    },

    {
        path: "/",
        element: <MainLayout />,
        errorElement: <RouterErrorBoundary />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard2`,
                element: <Dashboard2 />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/rifas`,
                element: <Rifas />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/numeros`,
                element: <Numeros />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/ganadores`,
                element: <Ganadores />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/pagos`,
                element: <Pagos />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/dashboard/numeros-especiales`,
                element: <NumerosEspeciales />,
                errorElement: <RouterErrorBoundary />,
            },

        ],
    },
    {
        path: "/",
        element: <PageLayout />,
        errorElement: <RouterErrorBoundary />,
        children: [
            {
                path: `/rifa/:idRifa/:nombre`,
                element: <PageDetail />,
                errorElement: <RouterErrorBoundary />,
            },
            {
                path: `/verificar-tickets`,
                element: <TicketVerification />,
                errorElement: <RouterErrorBoundary />,
            },

        ],
    },

]);
